<template>
  <section :id="['container-' + index + '-' + feedbackData.type]" :class="['container-' + feedbackData.type]">
		<div class="container-xl">
			<div class="feedback-wrapper">
				<h2>{{ feedbackData.config.title }}</h2>
				<div class="feedback-container">
					<iframe v-if="feedbackData.config.feedbackFormUrl" :src="feedbackData.config.feedbackFormUrl" class="ooiframe" id="ooimmoframe" name="ooimmoframe" width="100%" height="500" scrolling="no" frameborder="0" marginheight="0px" marginwidth="0px"></iframe>
	
					<p v-else>
						Dieser Block enthält kein Formular.
					</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	props: {
		feedbackData: {
			type: Object
		},
		index: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
	},

	mounted() {
		setTimeout(() => {			
			let ooIframe = document.createElement('script');    
			ooIframe.setAttribute('src',"https://res.onoffice.de/template/repository/iframeresizer/ooiframe-noscroll-v2.js");
			document.body.appendChild(ooIframe);
		}, 1000);
	}
	
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/feedbackComponent.scss";
</style>
